import React from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';

import FormComponent from './FormComponent';

import ValidationSchema from './ValidationSchema';

import {DisplayFormikState} from 'components/DisplayFormikState';

const RecordForm = ({ record, handleSubmit }) => {
    const onSubmit = (values) => {
        return handleSubmit(values);
    };

    const renderForm = (props) => {
        return (
            <React.Fragment>
                <FormComponent {...props} />
                {false && <DisplayFormikState {...props} />}
            </React.Fragment>
        );
    };

    let initialValues = {
        sso: false,
        terms: false,
    };

    if (record) {
        initialValues = record;
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={ValidationSchema}
            onSubmit={onSubmit}
        >
            {renderForm}
        </Formik>
    );
};

export default RecordForm;

RecordForm.propTypes = {
    record: PropTypes.object,
    handleSubmit: PropTypes.func,
};
